module.exports = __webpack_public_path__ + "media/images/corporate_pin-3bac31412ad077ed048694bb8aed992b.svg";